// @ts-ignore
 
import request from "src/lib/axios";

/** 分页查询员工列表 GET /api/v1/dashboard/staff */
export async function DashboardStaffControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStaffDtoArray>(
    "/api/v1/dashboard/staff",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // logicOperator has a default value: and
        logicOperator: "and",

        // sortOrder has a default value: DESC
        sortOrder: "DESC",

        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 邀请 / 添加员工 POST /api/v1/dashboard/staff */
export async function DashboardStaffControllerInviteV1(
  body: MyApi.InviteStaffDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputStaffDto>("/api/v1/dashboard/staff", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取员工详情（含角色） GET /api/v1/dashboard/staff/${param0} */
export async function DashboardStaffControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/dashboard/staff/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 更新员工资料（部门 / 岗位 / 管理员） PUT /api/v1/dashboard/staff/${param0} */
export async function DashboardStaffControllerUpdateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerUpdateV1Params,
  body: MyApi.UpdateStaffDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/dashboard/staff/${param0}`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 移除员工（解除成员关系） DELETE /api/v1/dashboard/staff/${param0} */
export async function DashboardStaffControllerRemoveV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerRemoveV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/dashboard/staff/${param0}`,
    {
      method: "DELETE",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 分配员工角色（全量覆盖） PUT /api/v1/dashboard/staff/${param0}/roles */
export async function DashboardStaffControllerAssignRolesV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerAssignRolesV1Params,
  body: MyApi.AssignStaffRolesDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/dashboard/staff/${param0}/roles`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 启用 / 停用员工 PUT /api/v1/dashboard/staff/${param0}/status */
export async function DashboardStaffControllerSetStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.DashboardStaffControllerSetStatusV1Params,
  body: MyApi.SetStaffStatusDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStaffDto>(
    `/api/v1/dashboard/staff/${param0}/status`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}
